import { render, staticRenderFns } from "./PromotionFaq.vue?vue&type=template&id=401354ac&scoped=true"
import script from "./PromotionFaq.vue?vue&type=script&lang=js"
export * from "./PromotionFaq.vue?vue&type=script&lang=js"
import style0 from "./PromotionFaq.vue?vue&type=style&index=0&id=401354ac&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401354ac",
  null
  
)

export default component.exports